import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PolicyListService} from '../service/policy-list.service';
import {NgxSpinnerService} from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ModErrorComponent} from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-policy-result',
  templateUrl: './policy-result.component.html'
})

export class PolicyResultComponent implements OnInit {
  data: any;
  dataPolicy: any;
  @Input() id: string;
  @Input() mode: string;

  constructor(private route: ActivatedRoute,
              private dataApi: PolicyListService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              private router: Router,
              public dialog: MatDialog) {
    this.route.snapshot.paramMap.get('id');
    this.id = this.route.snapshot.paramMap.get('id');
    this.mode = this.route.snapshot.paramMap.get('mode');
    if (!(this.mode === 'approved' || this.mode === 'request')) {
      this.router.navigate(['/404']);
    }
  }

  getPolicyDetails() {
    this.spinner.show('loading');
    this.dataApi.getPolicyDetails(this.id)
      .subscribe((data: any) => {
        this.data = data;
        this.dataPolicy = data.typePolicy;

        const typeEsNames = this.concatTypes(this.data.typePolicy, 'es');
        const typeEnNames = this.concatTypes(this.data.typePolicy, 'en');
        Object.assign(this.data, {typeEsNames, typeEnNames});

        this.spinner.hide('loading');
      }, (err) => {
        this.spinner.hide('loading');
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      });
  }

  getlang() {

    return sessionStorage.getItem('lang');
  }

  concatTypes(types, languaje) {
    let TypesConcat;
    if (languaje == 'es') {
      for (const type of types) {
        if (TypesConcat === undefined) {
          TypesConcat = type.NameEs;
        } else {
          TypesConcat = TypesConcat + ', \n' + type.NameEs;
        }
      }
    }
    if (languaje == 'en') {
      for (const type of types) {
        if (TypesConcat === undefined) {
          TypesConcat = type.Name;
        } else {
          TypesConcat = TypesConcat + ', \n' + type.Name;
        }
      }
    }
    return TypesConcat;
  }

  ngOnInit() {
    this.getPolicyDetails();

  }

}
